import { render } from "./Node.vue?vue&type=template&id=680e3722&scoped=true"
import script from "./Node.vue?vue&type=script&lang=js"
export * from "./Node.vue?vue&type=script&lang=js"

import "./Node.vue?vue&type=style&index=0&id=680e3722&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680e3722"]])

export default __exports__